/**
 * API Client for Compliance endpoints
 */

import { apiClient, handleApiError } from './apiClient';

export interface ComplianceSnapshotResponse {
  data: {
    gstPosition: {
      gstCollected: number;
      gstPaid: number;
      netGST: number;
      fromDate: string;
      toDate: string;
    };
    taxProvision: {
      accountingProfit: number;
      taxableIncome: number;
      taxRate: number;
      estimatedTax: number;
      financialYear: string;
    };
    superSummary: {
      totalSuper: number;
      employees: Array<{
        employeeId: string;
        employeeName: string;
        ordinaryTimeEarnings: number;
        superRate: number;
        superAmount: number;
      }>;
      rate: number;
      paydaySuperApplies: boolean;
      period: string;
      employeeCount?: number;
    };
    leaveProvisions: {
      totalAnnualLeave: number;
      totalLongServiceLeave: number;
      totalLeaveProvision: number;
      employees: Array<{
        employeeId: string;
        employeeName: string;
        annualLeaveProvision: number;
        longServiceLeaveProvision: number;
        lslVested: boolean;
        state: string;
        yearsOfService: number;
      }>;
    };
    basForecast: {
      quarter: string;
      gstOnSales: number;
      gstOnPurchases: number;
      netGST: number;
      grossWages: number;
      paygWithholding: number;
      paygInstalments: number;
      instalmentIncome: number;
      totalPayable: number;
      dueDate: string;
    };
    calculatedAt: string;
  };
}

export async function fetchComplianceSnapshot(): Promise<ComplianceSnapshotResponse['data']> {
  try {
    const response = await apiClient.get<ComplianceSnapshotResponse>('/compliance/snapshot');
    return response.data.data;
  } catch (error) {
    return handleApiError(error, 'Failed to fetch compliance data');
  }
}
